export interface InvoiceStatsData {
  totalInvoices: { value: number; percentageChange: number };
  totalPaidInvoices: { value: number; percentageChange: number };
  totalPendingInvoices: { value: number; percentageChange: number };
  totalOverDueInvoices: { value: number; percentageChange: number };
  totalCancelledInvoices: { value: number; percentageChange: number };
  totalDraftInvoice: { value: number; percentageChange: number };
  totalInvoiceValue: { value: number; percentageChange: number };
  totalRefundedInvoices: { value: number; percentageChange: number };
  dateRange: string;
  prevEndDate: string;
  prevStartDate: string;
}
export interface RecurringInvoiceStatsData {
  totalActiveReoccurring: number;
  totalPausedReoccurring: number;
  totalCancelledReoccurring: number;
  totalExpiredReoccurring: number;
  dateRange: string;
}
export type Filter =
  | { reoccurringStatus: string; isReoccurring: boolean | null }
  | { status: string; isReoccurring: boolean | null }
  | { billable: boolean | null; paymentMethod: string }
  | { stockStatus: string; variantStatus: string }
  | { status: string };

export type IRecurringInvoiceFilter =
  | { reoccurringStatus: string }
  | { billable: boolean | null; paymentMethod: string | null }
  | { stockStatus: string; variantStatus: string };

export type SalesStatus =
  | "pending"
  | "paid"
  | "due"
  | "draft"
  | "cancelled"
  | "refunded"
  | "Expired"
  | "Active"
  | "paused"
  | "Quote";

export type RecurringStatus = "cancelled" | "expired" | "active" | "paused";

export type IExpensePayment =
  | "card"
  | "cash"
  | "Bank Transfer"
  | "paystack"
  | "fluterwave";

export interface CompanyStatsData {
  totalInvoices: number;
  totalExpenses: number;
  totalCustomers: number;
  totalInventory: number;
  totalServices: number;
  dateRange: string;
}

export enum ServiceTypes {
  session_based = "session-based",
  time_based = "time-based",
}
